module.exports = "/_next/static/files/74c9287d350b581655af26a6aac57a74.png";